import React from 'react';

import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import PropTypes from 'prop-types';
import esLocale from 'date-fns/locale/es';
import DateFnsUtils from '@date-io/date-fns';
import {TextFieldProps, withStyles} from '@material-ui/core';

import {Messages} from 'commons/constants';
import {notEmpty} from 'commons/utils/Functions';
import {InferPropTypes} from 'commons/types/Types';
import {FieldTextStyles} from 'assets/tss/layouts/components';

EfeDatepicker.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    format: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    placeholder: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
};

function EfeDatepicker(
    props: InferPropTypes<
        typeof EfeDatepicker.propTypes & TextFieldProps,
        typeof FieldTextStyles
    >
) {
    const {
        classes,
        onChange,
        format,
        placeholder,
        required,
        value,
        error,
        ...other
    } = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
            <KeyboardDatePicker
                fullWidth
                autoOk={true}
                error={error}
                margin='none'
                format={format}
                variant='inline'
                required={required}
                onChange={onChange}
                label={placeholder}
                value={notEmpty(value) && value !== '' ? value : null}
                InputLabelProps={{
                    shrink: true,
                    className: classes.label,
                }}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                InputProps={{className: classes.input}}
                invalidDateMessage={Messages.INVALID_DATE_FORMAT}
                {...other}
            />
        </MuiPickersUtilsProvider>
    );
}

export default withStyles(FieldTextStyles)(EfeDatepicker);
